var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './Button.module.css';
import clsx from 'clsx';
import Spinner from '../spinner';
var Button = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'primary' : _b, _c = _a.size, size = _c === void 0 ? 'large' : _c, _d = _a.colorScheme, colorScheme = _d === void 0 ? 'gradient' : _d, className = _a.className, leftItem = _a.leftItem, rightItem = _a.rightItem, label = _a.label, onClick = _a.onClick, disabled = _a.disabled, loading = _a.loading, rest = __rest(_a, ["type", "size", "colorScheme", "className", "leftItem", "rightItem", "label", "onClick", "disabled", "loading"]);
    return (_jsxs("a", __assign({ className: clsx(styles.button, styles[size], disabled ? [styles.disabled, styles["disabled-".concat(type)]] : [styles[type], styles["".concat(type, "-").concat(colorScheme)]], !leftItem && !rightItem && type === 'link' && [styles['link-text'], styles["link-text-".concat(colorScheme)]], type === 'link' && styles["link-".concat(size)], className), onClick: disabled || loading ? undefined : onClick }, rest, { children: [leftItem !== null && leftItem !== void 0 ? leftItem : (loading && _jsx(Spinner, { color: type === 'primary' ? 'white' : '#4388dd', size: 12 }, void 0)), label && _jsx("span", { children: label }, void 0), rightItem] }), void 0));
};
export default Button;
